
<div class="list-group list-group-horizontal">
   <a *ngFor="let item of liste" [routerLink]="['/leverandorer', item.leverandorId]" class="list-group-item">                 
      {{item.rolle.navn}} {{item.leverandor.navn}}  
   </a>
</div>
               
